import { AuthenticationService as SharedAuthenticationService } from "@ucchub/ui";
import { BaseService } from "./BaseService";
import environment from "environment";

const AuthenticationService = SharedAuthenticationService({
  baseService: BaseService,
  auth: environment.api.auth,
  users: environment.api.users,
});

export default AuthenticationService;
